import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login.vue'
import QueryList from '@/components/query_list.vue'
import ImportDataExcel from '@/components/import_data_excel.vue'

import SetQueryCondition from '@/components/set_query_condition.vue'

import Registe from '@/components/registe.vue'
import UserForm from '@/components/user_form.vue'
import ImportExcel from '@/components/import_excel.vue'
import ExcelPreview from '@/components/excel_preview.vue'
import MakeForm from '@/components/make_form.vue'
import ReadMe from '@/components/read_me.vue'

import TableView from '@/components/tableView.vue'

// 核对数据表
import ValidationFormList from '@/components/validation_form_list.vue'

import ExcelDataPreview from '@/components/excel_data_preview.vue'
import ExcelDataImportFinalStep from '@/components/excel_data_import_final_step.vue'
import InputerList from '@/components/inputer_list.vue'
import InputerListDetail from '@/components/inputer_list_detail.vue'

import FormDetail from '@/components/form_detail.vue'

import BrowseAllData from '@/components/browse_all_data.vue'
import AddRecord from '@/components/add_record.vue'

import InvitedFormList from '@/components/invited_form_list.vue'

import ResetQueryConditions from '@/components/reset_query_conditions.vue'

import ImportDataExcelAi from '@/components/import_data_excel_ai.vue'
import ExcelDataPreviewAi from '@/components/excel_data_preview_ai.vue'
import ExcelDataImportFinalStepAi from '@/components/excel_data_import_final_step_ai.vue'



import ImportDataExcelEx from '@/components/import_data_excel_ex.vue'
import ExcelDataPreviewEx from '@/components/excel_data_preview_ex.vue'
import ExcelDataImportFinalStepEx from '@/components/excel_data_import_final_step_ex.vue'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/query_list',
      name: 'queryList',
      component: QueryList,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/registe',
      name: 'registe',
      component: Registe,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/user_form',
      name: 'user_form',
      component: UserForm,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/import_excel',
      name: 'import_excel',
      component: ImportExcel,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/excel_preview',
      name: 'excel_preview',
      component: ExcelPreview,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/table_view',
      name: 'table_view',
      component: TableView,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/make_form',
      name: 'make_form',
      component: MakeForm,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/read_me',
      name: 'read_me',
      component: ReadMe,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/validation_form_list',
      name: 'validation_form_list',
      component: ValidationFormList,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/import_data_excel',
      name: 'import_data_excel',
      component: ImportDataExcel,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/excel_data_preview',
      name: 'excel_data_preview',
      component: ExcelDataPreview,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/excel_data_import_final_step',
      name: 'excel_data_import_final_step',
      component: ExcelDataImportFinalStep,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/inputer_list',
      name: 'inputer_list',
      component: InputerList,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/inputer_list_detail',
      name: 'inputer_list_detail',
      component: InputerListDetail,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/set_query_condition',
      name: 'set_query_condition',
      component: SetQueryCondition,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/form_detail',
      name: 'form_detail',
      component: FormDetail,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/browse_all_data',
      name: 'browse_all_data',
      component: BrowseAllData,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/add_record',
      name: 'add_record',
      component: AddRecord,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/invited_form_list',
      name: 'invited_form_list',
      component: InvitedFormList,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/reset_query_conditions',
      name: 'reset_query_conditions',
      component: ResetQueryConditions,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/import_data_excel_ai',
      name: 'import_data_excel_ai',
      component: ImportDataExcelAi,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/excel_data_preview_ai',
      name: 'excel_data_preview_ai',
      component: ExcelDataPreviewAi,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/excel_data_import_final_step_ai',
      name: 'excel_data_import_final_step_ai',
      component: ExcelDataImportFinalStepAi,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/import_data_excel_ex',
      name: 'import_data_excel_ex',
      component: ImportDataExcelEx,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/excel_data_preview_ex',
      name: 'excel_data_preview_ex',
      component: ExcelDataPreviewEx,
      meta: {
        title: '万能快查'
      }
    },
    {
      path: '/excel_data_import_final_step_ex',
      name: 'excel_data_import_final_step_ex',
      component: ExcelDataImportFinalStepEx,
      meta: {
        title: '万能快查'
      }
    }


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js